import { render } from "./InsertTeacher.vue?vue&type=template&id=05de5201&scoped=true"
import script from "./InsertTeacher.vue?vue&type=script&lang=js"
export * from "./InsertTeacher.vue?vue&type=script&lang=js"

import "./InsertTeacher.vue?vue&type=style&index=0&id=05de5201&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05de5201"]])

export default __exports__